import { useState } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { Search01Icon } from "@hugeicons/core-free-icons";
import { Button } from "@/components/ui/button";
import {
  AccountResultTable,
  MoveCompanyDialog,
  useAdminAccountSearch,
  type AdminAccountSearchItem,
} from "@/features/account";

export default function AccountsPage() {
  const [inputValue, setInputValue] = useState("");
  const [keyword, setKeyword] = useState("");
  const [moveTarget, setMoveTarget] = useState<AdminAccountSearchItem | null>(null);

  const { data, isLoading } = useAdminAccountSearch(keyword);

  const handleSearch = () => setKeyword(inputValue.trim());

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <div className="flex h-full flex-col gap-4 bg-slate-50/50 p-4">
      <div>
        <h1 className="text-xl font-bold text-gray-900">계정 도구</h1>
        <p className="mt-0.5 text-xs text-gray-600">
          로그인 아이디로 계정을 찾아 소속 배차 업체를 옮기거나 내부 개발자 권한을 부여합니다
        </p>
      </div>

      <div className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="로그인 아이디 (부분일치)"
          autoFocus
          className="h-7 w-64 rounded-md border border-gray-300 px-3 text-xs text-gray-700 outline-none focus:border-blue-500"
        />
        <Button
          size="sm"
          onClick={handleSearch}
          className="h-7 bg-blue-600 px-3 text-xs font-bold hover:bg-blue-700"
        >
          <HugeiconsIcon icon={Search01Icon} size={14} className="mr-1" />
          검색
        </Button>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto">
        <AccountResultTable
          accounts={data?.accounts ?? []}
          isLoading={isLoading}
          hasKeyword={keyword.length > 0}
          onMoveCompany={setMoveTarget}
        />

        <p className="mt-3 text-[11px] leading-relaxed text-gray-500">
          내부 개발자 권한은 배포 후 검증용 내부 도구(통계·차량 스펙 관리·CTI/Agent24 진단)와 인수증
          파일검증 우회에 쓰입니다. 로그인 토큰에 담기므로 <b>대상자가 재로그인해야 적용</b>됩니다.
        </p>
      </div>

      <MoveCompanyDialog account={moveTarget} onClose={() => setMoveTarget(null)} />
    </div>
  );
}
